import { isSafari } from "~/modules/helpers/functions/isSafari";

export function useScrollTo(
  watchRef?: Ref<any> | Ref<any>[],
  targetElementSelector?: Ref<string> | string,
  options?: {
    behavior?: ScrollBehavior;
    forceSmoothForSafari?: boolean;
  },
) {
  let behavior = options?.behavior ?? "smooth";

  /** there is an issue with smooth scrolling on safari with dynamic page height **/
  if (behavior === "smooth" && isSafari() && !options?.forceSmoothForSafari) {
    behavior = "instant";
  }

  function scrollToTop() {
    if (import.meta.client) {
      document.scrollingElement?.scrollTo({
        top: 0,
        left: 0,
        behavior,
      });
    }
  }

  function scrollToTarget(targetSelector?: string) {
    const selector = targetSelector ?? unref(targetElementSelector);
    if (!selector) {
      console.warn(`Scroll to taget has been failed, no selector specified`);
      return false;
    }
    const el = document.querySelector(selector);

    if (!el) {
      console.warn(
        `Scroll to target has been failed, no taget element by selector ${selector}`,
      );
      return false;
    }

    el.scrollIntoView({
      behavior,
    });
  }

  if (watchRef) {
    watch(watchRef, () => {
      setTimeout(() => {
        if (targetElementSelector && unref(targetElementSelector)) {
          scrollToTarget(unref(targetElementSelector));
        } else {
          scrollToTop();
        }
      });
    });
  }

  return {
    scrollToTarget,
    scrollToTop,
  };
}
